<template>
  <label
    class="mb-1 block text-left text-sm font-medium text-background-fg/70"
  >
    <slot />
  </label>
</template>
